import { useTheme } from '@mui/material';

export const PatientChartIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none">
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeWidth={1.5}
                d="M14.462 15.67h17.35m-17.35 10.154h14.719m-14.719 3.772h6.04"
            />
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="m3.212 15.92 2.5 2.5 5.5-5.5m-8 14.176 2.5 2.5 5.5-5.5m25.792-13.669c0-1.98-1.226-6.6-5.47-6.847-5.158-.3-14.449-.365-18.712 0-1.141.065-4.94.96-5.421 5.094m0 25.82c1.755 2.137 11.723 2.4 16.357 2.4 4.176 0 7.321-.566 7.321-.566 2.159-.562 5.925-1.284 5.925-7.936 0-1.46.002-2.994.005-4.535"
            />
        </svg>
    );
};
